"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var currency_1 = require("../../../../../formatters/currency");
var padding_1 = require("../../../../padding");
var text_1 = require("../../../../text");
var editable_cell_1 = (0, tslib_1.__importDefault)(require("./editable-cell"));
var table_1 = require("./table");
function EditableRow(props) {
    var id = props.id, label = props.label, value = props.value, onChange = props.onChange, isEditable = props.isEditable;
    function onUpdatedValueChange(newValue) {
        onChange({
            current: value.current,
            updated: newValue,
        });
    }
    function onDifferenceValueChange(newValue) {
        onChange({
            current: value.current,
            updated: value.current + newValue,
        });
    }
    return (react_1.default.createElement(table_1.StyledRow, null,
        react_1.default.createElement(table_1.StyledCell, null,
            react_1.default.createElement(table_1.StyledLabel, null,
                react_1.default.createElement(padding_1.Padding, { size: 12 },
                    react_1.default.createElement(text_1.Text, { size: "small", nowrap: true, truncate: true },
                        react_1.default.createElement("strong", null, label))))),
        react_1.default.createElement(table_1.StyledCell, { disabled: true },
            react_1.default.createElement(padding_1.Padding, { size: 12 },
                react_1.default.createElement(text_1.Text, { size: "small" }, (0, currency_1.currencyFormat)(value.current)))),
        react_1.default.createElement(editable_cell_1.default, { testId: "".concat(id, "-difference"), isEditable: isEditable, onChange: function (newValue) {
                onDifferenceValueChange(newValue || 0);
            }, value: value.updated - value.current }),
        react_1.default.createElement(editable_cell_1.default, { testId: "".concat(id, "-updated"), isEditable: isEditable, onChange: function (newValue) {
                if (newValue) {
                    onUpdatedValueChange(newValue);
                }
                else {
                    onDifferenceValueChange(0);
                }
            }, value: value.updated })));
}
exports.default = EditableRow;
//# sourceMappingURL=editable-row.js.map